export class Branch {
  selectedBranch: string;
  defaultBranch: string;
  branches: string[];
}

export class BreadCrumbConfig {
  blueprint: string = '';
  environment: string = '';
  clusterId: string = '';
  resourceType: string = '';
  resource: string = '';
  branch?: Branch;
}

export class PagePath {
  parent: string = '';
  children: string[] = [];
  context: string = '';
}
